const TicimaxMenuTypes = {
    CHANNEL: {
        id: "detail",
        group: "settings_group",
        path: "detail",
        label: "Detail",
        tabs: [],
        implemented: true,
    },
    VISIBILITY: {
        id: "visibility",
        group: "settings_group",
        path: "visibility",
        label: "Visibility",
        tabs: [],
        implemented: true,
    },
    MEMBERS: {
        id: "members",
        group: "members",
        path: "members",
        label: "Members",
        tabs: [],
        implemented: true,
    },
    AUTOMATION: {
        id: "automation",
        group: "automation",
        path: "automation",
        label: "Automations",
        tabs: [],
        implemented: true,
    },
};

export default TicimaxMenuTypes;
